import {
  CalendarProps,
  FormField,
  Box,
  Grid,
} from "@cloudscape-design/components-themed";
import { NonCancelableEventHandler } from "@cloudscape-design/components-themed/internal/events";
import { LABELS } from "../../examinations-status/constants";
import { DatePicker } from "./DatePicker";

interface IPeriodDatePicker {
  label?: string;
  disabled?: boolean;
  startDate: string;
  startDateOnChange: NonCancelableEventHandler<CalendarProps.ChangeDetail>;
  endDate: string;
  endDateOnChange: NonCancelableEventHandler<CalendarProps.ChangeDetail>;
}

/**
 * 日付範囲選択コンポーネント
 */
const PeriodDatePicker = (props: IPeriodDatePicker) => {
  const {
    label = "　",
    disabled = false,
    startDate,
    startDateOnChange,
    endDate,
    endDateOnChange,
  } = props;

  return (
    <Grid gridDefinition={[{ colspan: 5 }, { colspan: 1 }, { colspan: 5 }]}>
      <FormField label={label}>
        <DatePicker
          value={startDate}
          onChange={startDateOnChange}
          disabled={disabled}
        />
      </FormField>
      <Box padding={{ top: "xxl" }} variant="awsui-key-label">
        {LABELS.WAVE}
      </Box>
      <FormField label={"　"}>
        <DatePicker
          value={endDate}
          onChange={endDateOnChange}
          disabled={disabled}
        />
      </FormField>
    </Grid>
  );
};

export default PeriodDatePicker;
